import React from "react";
import "./ChemPesticidesTable.css";
import { Table } from "antd";
import ChemPesticidesTableRow from "./ChemPesticidesTableRow";
import ChemPesticidesTableCell from "./ChemPesticidesTableCell";

function ChemPesticidesTable({
  batchReportView,
  samples,
  loading,
  tableColumns,
  openModal,
}) {
  return (
    <Table
      sticky
      bordered
      dataSource={samples}
      loading={loading}
      pagination={false}
      className={`ChemPesticidesTable ChemPesticidesTable__StickyChange${batchReportView ? "--batch-report" : ""}`}
      tableLayout="fixed"
      components={{
        body: {
          row: ChemPesticidesTableRow,
          cell: ChemPesticidesTableCell,
        },
      }}
      onRow={(record, index) => (
        { record, index }
      )}
      columns={tableColumns.map((col) => ({
        ...col,
        onCell: (record) => ({
          record,
          dataIndex: col.dataIndex,
          title: col.title,
          openModal,
          loading,
        }),
      }))}
    />
  );
}

export default ChemPesticidesTable;
